import React, { FC, useEffect, useRef, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import cs from 'classnames';
import '@wix/design-system/styles.global.css';
import { useExperiments } from '../../contexts/ExperimentsContext';
import { useFedopsLogger } from '../../contexts/FedopsLoggerContext';
import { appRoutes } from '../../routes';
import { useTemplates } from '../../hooks/useTemplates';
import TemplatesPage from '../TemplatesPage/TemplatesPage';
import { TemplatePreviewModal } from '../TemplatePreviewModal/TemplatePreviewModal';
import { BiLoggerProvider } from '../../contexts/BILoggerContext';
import { PreviewTemplateContextProvider } from '../../contexts/PreviewTemplateContext';
import { HtmlHead } from '../HtmlHead/HtmlHead';
import { SidePanel } from '../SidePanel/SidePanel';
import { Footer } from '../Footer/Footer';
import { PageScrollContextProvider } from '../../contexts/PageScrollContext';
import { Template } from '../../domain/entities/template';
import { SubHeaderWithSearch } from '../SubHeaderWithSearch/SubHeaderWithSearch';
import { TopBar } from '../TopBar/TopBar';

import s from './App.scss';

const App: FC = () => {
  const topRef = useRef<HTMLDivElement>(null);
  const fedopsLogger = useFedopsLogger();
  const experiments = useExperiments();
  const { templates } = useTemplates();

  const [previewTemplate, setPreviewTemplate] = useState<Template | null>(null);
  const [isSavedTemplate, setIsSavedTemplate] = useState(false);

  useEffect(() => {
    fedopsLogger.reportAppLoaded();

    // TODO: refactor this
    const urlParams = new URLSearchParams(window.location.search);
    const savedTemplateSlug = urlParams.get('savedTemplateSlug');

    if (savedTemplateSlug) {
      const savedTemplate = templates.find(
        (temp) => temp.slug === savedTemplateSlug,
      );
      setPreviewTemplate(savedTemplate || null);
      setIsSavedTemplate(true);
    }
  }, []);

  const isTopBarEnabled = experiments.is(
    'specs.funnel.StudioTemplatesNewTopBar',
    'true',
  );

  return (
    <div>
      <PreviewTemplateContextProvider
        previewTemplate={previewTemplate}
        setPreviewTemplate={setPreviewTemplate}
      >
        {previewTemplate && (
          <TemplatePreviewModal
            template={previewTemplate}
            isSaved={isSavedTemplate}
            setIsSaved={setIsSavedTemplate}
          />
        )}
        <div className={isTopBarEnabled ? s.subHeaderWithTopBar : undefined}>
          <SubHeaderWithSearch />
        </div>
        {isTopBarEnabled && (
          <div className={s.topBar}>
            <TopBar />
          </div>
        )}
        <div ref={topRef} className={s.topTarget} />
        <div className={cs(s.content, { [s.withTopBar]: isTopBarEnabled })}>
          <Routes>
            <Route
              path={appRoutes.templates.pattern}
              element={
                <PageScrollContextProvider topPageRef={topRef}>
                  <BiLoggerProvider>
                    <SidePanel />
                    <HtmlHead />
                    <TemplatesPage />
                  </BiLoggerProvider>
                </PageScrollContextProvider>
              }
            />
          </Routes>
        </div>
        <Footer />
      </PreviewTemplateContextProvider>
    </div>
  );
};

export default App;
